export default {
  title: "Metodi d'ordine",
  paywall: {
    live_title: '{{name}} è online!',
  },
  tabs: {
    general: 'Generale',
    pickup: 'Ritiro',
    delivery: 'Consegna',
    room_service: 'Servizio in camera/tavolo',
  },
  modals: {
    update_confirmation: {
      title: 'Sei sicuro di voler salvare le nuove modifiche?',
      buttons: {
        confirm: 'Conferma',
        cancel: 'Annulla',
      },
    },
    switch_live_orders: {
      titles: {
        disable: 'Sei sicuro di voler disabilitare gli ordini live?',
        enable: 'Sei sicuro di voler attivare gli ordini live?',
      },
      buttons: {
        yes: 'Sì',
        no: 'No',
      },
    },
  },
  toasts: {
    failed_to_save_changes: 'Salvataggio modifiche non riuscito',
    changes_got_saved: 'Modifiche salvate',
  },
};
